import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async liberarEntradaBloqueada(api, parametros) {
    parametros.operacao = 'liberarEntradaBloqueada';

    let retorno = {};

    await api.santriPOST('/rest/entrada', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REntrada/REntradaLiberarEntradaBloqueada.js